/**
 * HC Cart - Complete Self-Contained Cart Management
 * Uses shared HC Cart Utils for common functionality
 */

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  initializeHCCart();
});

// Also handle cases where DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHCCart);
} else {
  initializeHCCart();
}

function initializeHCCart() {
  // Ensure we don't initialize multiple times
  if (window.hcCartInitialized) {
    return;
  }
  window.hcCartInitialized = true;

  console.log('Initializing HC Cart...');
  
  // Initialize cart components
  initializeCartRemoveButtons();
  initializeCartItems();
  initializeCartNotes();
  initializeQuantityInputs();
  
  console.log('HC Cart initialized successfully');
}

function initializeCartRemoveButtons() {
  // Handle existing remove buttons
  const existingRemoveButtons = document.querySelectorAll('hc-cart-remove-button');
  existingRemoveButtons.forEach(button => {
    if (!button.hcInitialized) {
      setupRemoveButton(button);
    }
  });

  // Watch for dynamically added remove buttons
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'HC-CART-REMOVE-BUTTON') {
            setupRemoveButton(node);
          }
          // Also check for remove buttons within added nodes
          const removeButtons = node.querySelectorAll && node.querySelectorAll('hc-cart-remove-button');
          if (removeButtons) {
            removeButtons.forEach(button => {
              if (!button.hcInitialized) {
                setupRemoveButton(button);
              }
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function setupRemoveButton(element) {
  // Use shared utility
  window.HCCartUtils.setupRemoveButton(element);
}

function initializeCartItems() {
  // Handle existing cart items
  const existingCartItems = document.querySelectorAll('hc-cart-items');
  existingCartItems.forEach(cartItems => {
    if (!cartItems.hcInitialized) {
      setupCartItems(cartItems);
    }
  });

  // Watch for dynamically added cart items
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'HC-CART-ITEMS') {
            setupCartItems(node);
          }
          // Also check for cart items within added nodes
          const cartItems = node.querySelectorAll && node.querySelectorAll('hc-cart-items');
          if (cartItems) {
            cartItems.forEach(item => {
              if (!item.hcInitialized) {
                setupCartItems(item);
              }
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function setupCartItems(element) {
  if (element.hcInitialized) return;
  element.hcInitialized = true;

  // Add methods to the element
  element.updateQuantity = function(line, quantity, name, variantId) {
    updateQuantity(element, line, quantity, name, variantId);
  };

  element.enableLoading = function(line) {
    enableLoading(element, line);
  };

  element.disableLoading = function() {
    disableLoading(element);
  };

  element.disableAllQuantityButtons = function() {
    disableAllQuantityButtons(element);
  };

  element.enableAllQuantityButtons = function() {
    enableAllQuantityButtons(element);
  };

  element.resetRemoveButtonStates = function() {
    resetRemoveButtonStates(element);
  };
}

function initializeQuantityInputs() {
  // Handle existing quantity inputs
  const existingQuantityInputs = document.querySelectorAll('quantity-input');
  existingQuantityInputs.forEach(input => {
    if (!input.hcInitialized) {
      setupQuantityInput(input);
    }
  });

  // Watch for dynamically added quantity inputs
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'QUANTITY-INPUT') {
            setupQuantityInput(node);
          }
          // Also check for quantity inputs within added nodes
          const quantityInputs = node.querySelectorAll && node.querySelectorAll('quantity-input');
          if (quantityInputs) {
            quantityInputs.forEach(input => {
              if (!input.hcInitialized) {
                setupQuantityInput(input);
              }
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function setupQuantityInput(element) {
  // Use shared utility with cart-specific options
  window.HCCartUtils.setupQuantityInput(element, {
    onUpdate: function(line, quantity, name, variantId) {
      const cartItems = element.closest('hc-cart-items') || element.closest('cart-items');
      if (cartItems && cartItems.updateQuantity) {
        cartItems.updateQuantity(line, quantity, name, variantId);
      }
    }
  });
}

function updateQuantity(cartItemsElement, line, quantity, name, variantId) {
  // Use shared utility
  window.HCCartUtils.updateQuantity(line, quantity, name, variantId, {
    onSuccess: function(parsedState) {
      window.location.reload();
    },
    onEmpty: function() {
      window.location.reload();
    }
  });
}

function enableLoading(cartItemsElement, line) {
  const mainCartItems = document.getElementById('main-cart-items') || 
                       document.getElementById('CartDrawer-CartItems');
  
  if (mainCartItems) {
    mainCartItems.classList.add('cart__items--disabled');
  }

  // Show loading overlay for specific item
  const cartItemElements = cartItemsElement.querySelectorAll(`#CartItem-${line} .loading-overlay`);
  const cartDrawerItemElements = cartItemsElement.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
  
  [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
    overlay.classList.remove('hidden');
  });

  document.activeElement?.blur();
  
  const lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || 
                               document.getElementById('CartDrawer-LineItemStatus');
  
  if (lineItemStatusElement) {
    lineItemStatusElement.setAttribute('aria-hidden', false);
  }
}

function disableLoading(cartItemsElement) {
  const mainCartItems = document.getElementById('main-cart-items') || 
                       document.getElementById('CartDrawer-CartItems');
  
  if (mainCartItems) {
    mainCartItems.classList.remove('cart__items--disabled');
  }

  // Hide all loading overlays
  cartItemsElement.querySelectorAll('.loading-overlay').forEach((overlay) => {
    overlay.classList.add('hidden');
  });
}

function disableAllQuantityButtons(cartItemsElement) {
  const quantityButtons = cartItemsElement.querySelectorAll('button[name="plus"], button[name="minus"]');
  quantityButtons.forEach(button => {
    button.disabled = true;
    button.classList.add('disabled');
  });
}

function enableAllQuantityButtons(cartItemsElement) {
  const quantityButtons = cartItemsElement.querySelectorAll('button[name="plus"], button[name="minus"]');
  quantityButtons.forEach(button => {
    button.disabled = false;
    button.classList.remove('disabled');
  });
}

function resetRemoveButtonStates(cartItemsElement) {
  const removeButtons = cartItemsElement.querySelectorAll('hc-cart-remove-button');
  removeButtons.forEach(removeButton => {
    setRemoveButtonLoadingState(removeButton, false);
  });
}

function setRemoveButtonLoadingState(element, isLoading) {
  const button = element.querySelector('button');
  if (!button) return;
  
  if (isLoading) {
    button.disabled = true;
    button.classList.add('loading');
    button.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="loading-spinner">
        <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" fill="none" opacity="0.3"/>
        <path d="M8 2a6 6 0 0 1 6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round">
          <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" values="0 8 8;360 8 8"/>
        </path>
      </svg>
    `;
  } else {
    button.disabled = false;
    button.classList.remove('loading');
    button.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }
}

function initializeCartNotes() {
  // Handle existing cart notes
  const existingCartNotes = document.querySelectorAll('hc-cart-note');
  existingCartNotes.forEach(cartNote => {
    if (!cartNote.hcInitialized) {
      setupCartNote(cartNote);
    }
  });

  // Watch for dynamically added cart notes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'HC-CART-NOTE') {
            setupCartNote(node);
          }
          // Also check for cart notes within added nodes
          const cartNotes = node.querySelectorAll && node.querySelectorAll('hc-cart-note');
          if (cartNotes) {
            cartNotes.forEach(note => {
              if (!note.hcInitialized) {
                setupCartNote(note);
              }
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function setupCartNote(element) {
  if (element.hcInitialized) return;
  element.hcInitialized = true;

  const onChangeHandler = window.HCCartUtils.debounce(function(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .catch(error => console.error('Cart note update error:', error));
  }, 300);

  element.addEventListener('change', onChangeHandler);
}